import {DashboardRepository} from '../repositories/DashboardRepository';
import {RecentScan} from '../entities/DashboardData';

export class GetDeliveriesByCreatedUserUseCase {
  constructor(private readonly repository: DashboardRepository) {}

  async execute(): Promise<RecentScan[]> {
    return await this.repository.getDeliveriesByCreatedUser();
  }
}
